import { createContext, ReactNode, useContext, useEffect, useState } from "react"


interface ProyectoProviderProps {
    children: ReactNode;
}

const ProyectoContext = createContext<{ idProy: number; setIdProy: (id: number) => void } | null>(null);


export const ProyectoProvider: React.FC<ProyectoProviderProps> = ({ children }) => {
    const [idProy, setIdProy] = useState<number>(() => {
        return Number(localStorage.getItem("idProy")) || 0;
    });

    useEffect(() => {
        localStorage.setItem("idProy", idProy.toString());
    }, [idProy]);

    return (
        <ProyectoContext.Provider value={{ idProy, setIdProy }}>
            {children}
        </ProyectoContext.Provider>
    );
};

export const useProyecto = () => {
    const context = useContext(ProyectoContext);
    if (!context) {
        throw new Error("useProyecto debe usarse dentro de un ProyectoProvider");
    }
    return context;
};